import React from 'react';
import './../css/HeadingStyle.css';

const HeadingStyle = (props) => {
  return (
    <React.Fragment>
      <div>
        <h1 className="display-4 mt-5" style={{ letterSpacing: '9px', fontWeight: '400' }}>
          {props.uppertext}
        </h1>
        <h1 className="bold-text bg-text">{props.lowertext}</h1>
      </div>
    </React.Fragment>
  );
};

export default HeadingStyle;
